import makeStyles from '@mui/styles/makeStyles';
import { useCurrentUser } from '@/contexts/CurrentUserContext';
import { GHG_SCOPE_3_PATH } from '@/utils/constants';
import {
  EMISSION_SOURCE_PARENT_OBJECT,
  getEmissionSourceParent,
  isGraphTypeEmission,
  SCOPE_1_AND_2_SOURCE_TYPES,
  SCOPE_3_SOURCE_TYPES,
} from '../../../../pages/GHG/Charts/utils';
import CheckList from '../../../CheckList';

const useStyles = makeStyles(theme => ({
  checkListRoot: {
    height: 'auto',
    padding: 0,
  },
  checkListForm: {
    width: '100%',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    flexDirection: 'row',
    '& > :first-of-type': {
      marginLeft: '-6px',
    },
  },
  label: {
    ...theme.palette.alternateText,
    fontWeight: 'bold',
  },
  parentAndChildContainer: {
    margin: '0 5px',
  },
  checkboxLabel: {
    '& > .MuiFormControlLabel-label': {
      fontWeight: 'bold',
    },
  },
}));

export default ({ graphType, handleSetState, itemIsDisabledParams, value }) => {
  const classes = useStyles();
  const { isUserEntitled } = useCurrentUser();
  const renderScope3 = isUserEntitled(GHG_SCOPE_3_PATH);

  const emissionSourceTypes = [...SCOPE_1_AND_2_SOURCE_TYPES, ...SCOPE_3_SOURCE_TYPES];

  const callback = newSources => handleSetState(newSources, 'emissionsSource');

  return (
    <>
      {value && emissionSourceTypes && (
        <CheckList
          callback={callback}
          checked={value}
          allSelectableWhenChildrenDisabled
          selectAllOnNoneChecked
          label='Emission Sources'
          list={emissionSourceTypes}
          nameKey='label'
          isDisabled={!isGraphTypeEmission(graphType)}
          itemIsDisabledParams={{ ...itemIsDisabledParams, renderScope3 }}
          getParent={getEmissionSourceParent}
          customItems={EMISSION_SOURCE_PARENT_OBJECT}
          styles={classes}
          color='primary'
        />
      )}
    </>
  );
};
